export default {
  deep: "DEEP",
  search: "Suche...",
  roles: {
    admin: "Admin",
    controlCenter: "Leitstelle",
  },
};
